/**
 * Apple Intelligence journey — protocol `discovery-only` (ADR-0159 §3).
 * Applebot-Extended is Apple's documented opt-out training signal.
 */

import { buildDiscoveryOnlyTerminalPhase } from './discovery-only-terminal.js';
import { buildDiscoveryPhase, buildReadMenuPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildAppleJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl, catalogUrl, liveProducts } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    buildReadMenuPhase(agent, installed, catalogUrl, live.catalog, liveProducts),
    buildDiscoveryOnlyTerminalPhase(agent),
  ];
}
